import { makeStyles, tokens } from "@fluentui/react-components";
import { NHColors } from "utils/generalUtils";

export const useStyles = makeStyles({
    grid: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: tokens.spacingHorizontalS
    },
    row: {
        display: "flex",
        alignItems: "center",
        columnGap: tokens.spacingHorizontalS,
        rowGap: tokens.spacingVerticalXS,
        flexWrap: "wrap"
    },
    controls: {
        display: "flex",
        flexWrap: "wrap",
        gap: tokens.spacingHorizontalS
    },
    micSelect: {
        padding: "4px 8px",
        fontSize: "12px",
        maxWidth: "320px"
    },
    subtleText: {
        fontSize: "12px",
        opacity: 0.75
    },
    error: {
        color: "#c50f1f",
        fontSize: "12px",
        marginTop: "4px"
    },
    inputAreaRoot: {
        border: "none",
        minHeight: "88px",
        borderBottom: `4px solid ${NHColors.primaryOld}`,
        ':focus': {
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: `4px solid ${NHColors.primaryOld}`,
        },
        ':focus-within': {
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: `4px solid ${NHColors.primaryOld}`,
        },
        ':hover': {
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: `4px solid ${NHColors.primaryOld}`,
        },
        ':active': {
            outline: 'none',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: `4px solid ${NHColors.primaryOld}`,
        }
    },
    inputArea: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        width: "80%",
        backgroundColor: '#f3f5f8ff',
        marginTop: "1rem",
        borderTop: "none",
        borderBottom: `4px solid ${NHColors.primaryOld}`,
        borderRadius: "0.5rem",
        minHeight: '88px',
        ':focus': {
            borderTop: "none",
            borderBottom: `4px solid ${NHColors.primaryOld}`,
        },
        ':active': {
            outline: 'none', borderTop: "none",
            borderBottom: `4px solid ${NHColors.primaryOld}`,
        }
    },
    textareaSlot: {
        overflowY: "auto",
        resize: "none",
        maxHeight: "40vh",
        fontSize: "20px",
        fontStyle: "Italic",
        backgroundColor: '#f3f5f8ff',
        borderRadius: "0.5rem",
        border: 'none',
        outline: 'none',
        background: 'transparent',
        padding: '12px 16px',
        ':focus': {
            border: 'none',
        },
        ':focus-within': {
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
        },
        ':hover': {
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
        },
        ':active': {
            outline: 'none', borderTop: "none",
        }
    },
    submitButton: {
        width: "200px",
        minHeight: "40px",
        backgroundColor: NHColors.primary,
        color: "white",
        fontWeight: 600,
        padding: "0.75rem 1rem",
        borderRadius: "0.5rem",
        ":hover": {
            backgroundColor: NHColors.primary,
            color: 'white'
        }
    },
});